import { render } from "./404.vue?vue&type=template&id=1dc2bb9f&scoped=true&bindings={}"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=1dc2bb9f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1dc2bb9f"

export default script